import clsx from 'clsx';
import A from 'components/atoms/A/A';
import Card from 'components/atoms/Card/Card';
import Currency from 'components/atoms/Currency/Currency';
import Txt from 'components/atoms/Txt/Txt';
import { useCallback } from 'react';
import Chevron from './assets/Chevron';
import Icon from './assets/mobiworkx-survey-icon.svg';
import classes from './SurveyCard.module.scss';

export type Props = {
  surveyId: string;
  title?: string;
  surveyUrl?: string;
  duration: number;
  amount: number;
  disabled?: boolean;
  baseAmount?: number;
  onSurveyClick?: () => void;
  className?: string;
  tags?: ReadonlyArray<string>;
  currency?: string;
  isOnGoingSurvey?: boolean;
};

export default function SurveyCardStatic(props: Props) {
  const Inner = useCallback(
    ({ surveyId, duration, amount, disabled }: Props) => (
      <div
        className={clsx(
          classes.root,
          disabled ? classes.disabled : '',
          !disabled && classes.hoverEffects,
        )}
      >
        <div className={classes.link}>
          <div className={classes.supportingInfo}>
            <Icon />
            <span className={classes.id}>
              <Txt>Survey ID: {{ surveyId }}</Txt>
            </span>
          </div>
          <div className={classes.primaryContent}>
            <Currency
              amount={amount}
              currency="USD"
              className={classes.points}
              numberClassName={classes.amount}
              currencyClassName={classes.currencySymbol}
            />
            <Txt className={classes.duration}>
              <Txt className={classes.minutes} skipTranslation>
                {{ duration: duration }}
              </Txt>{' '}
              <span className={classes.units}>mins</span>
              <Chevron className={classes.chevron} />
            </Txt>
          </div>
        </div>
      </div>
    ),
    [],
  );

  return (
    <Card className={clsx(classes.root, props.className)} isLink>
      {props.surveyUrl && !props.disabled ? (
        <A
          href={props.surveyUrl}
          className={classes.link}
          target="_blank"
          onClick={props.onSurveyClick}
        >
          <Inner {...props} />
        </A>
      ) : (
        <div className={classes.link}>
          <Inner {...props} />
        </div>
      )}
    </Card>
  );
}
